module.exports = __webpack_public_path__ + "media/lisa.3f31f16a.mp4";